import React, { memo } from "react";
import { withNamespaces } from "react-i18next";
import { Button, FormGroup, Label } from "reactstrap";
import HTMLContent from "src/components/Common/HTMLContent";

const UserResponsePreview = ({
  t,
  subject,
  bodyHtml,
  verificationSteps = [],
  retentionNotes,
  isReadOnly,
  onCopyToMessages,
  copyDisabled = false,
}) => {
  const hasContent = !!bodyHtml?.trim();

  return (
    <FormGroup className="mb-0">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <Label className="mb-0 lia-tab__field-label">{t("Response Preview")}</Label>
        {!isReadOnly && hasContent && (
          <Button
            color="primary"
            outline
            size="sm"
            onClick={onCopyToMessages}
            disabled={copyDisabled}
          >
            {t("Copy to Messages")}
          </Button>
        )}
      </div>

      {hasContent && subject && (
        <p className="text-muted mb-2">
          <strong>{t("Subject")}:</strong> {subject}
        </p>
      )}

      <div
        className={`lia-tab__response-preview${
          hasContent ? "" : " lia-tab__response-preview--empty"
        }`}
      >
        {hasContent ? (
          <HTMLContent content={bodyHtml} />
        ) : (
          <span className="lia-tab__response-preview-placeholder">
            {t("Dear user...")}
          </span>
        )}
      </div>

      {hasContent && verificationSteps?.length > 0 && (
        <div className="mt-3">
          <Label>{t("Verification steps")}</Label>
          <ul className="mb-0 ps-3">
            {verificationSteps.map((step, index) => (
              <li key={`${step}-${index}`}>{step}</li>
            ))}
          </ul>
        </div>
      )}

      {hasContent && retentionNotes && (
        <p className="text-muted mb-0 mt-3">
          <strong>{t("Retention notes")}:</strong> {retentionNotes}
        </p>
      )}
    </FormGroup>
  );
};

export default withNamespaces()(memo(UserResponsePreview));
